import React from "react";
import heroImage from './hero.webp';
import { FormContact } from "../../Contact/components/FormContact";

export const Hero = () => {
    return (
        <div
            className="hero min-h-screen w-full"
            style={{
                backgroundImage: `url(${heroImage})`,
            }}>
            <div className="hero-overlay bg-opacity-40"></div>
            <div className="hero-content text-neutral-content">
                <main>
                    <div className="md:hidden lg:hidden xl:hidden">
                        <h1 className="mb-5 text-4xl font-bold mb-5 text-[#fff]">Prenez soin de votre maison et de votre jardin toute l'année avec notre expertise en Franche-comté</h1>
                        <div className="flex flex-row items-center justify-center gap-2">
                            <a href="#services" className="btn btn-primary text-white rounded-full">Découvrez nos services</a>
                            <a href="#contact" className="btn btn-accent text-white rounded-full">Obtenir un devis</a>
                        </div>
                    </div>
                    <div className="hidden xl:flex lg:flex md:flex flex-row items-center">
                        <div className="basis-1/2">
                    <h1 className="mb-5 text-4xl font-bold text-left mb-5">Prenez soin de votre maison et de votre jardin toute l'année avec notre expertise en Franche-comté</h1>
                    <div className="flex flex-row items-center flex-start gap-2">
                        <a href="#services" className="btn btn-primary text-white rounded-full">Découvrez nos services</a>
                        <a href="#contact" className="btn btn-accent text-white rounded-full">Nous contacter</a>
                    </div>
                    </div>
                    <div className="bg-base-100 basis-1/2 lg:basis-1/3 rounded-xl w-full">
                        <FormContact/>
                    </div>
                    </div>
                </main>
            </div>
        </div>
    )
}